(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    const alignZymMenus = () => {
    document.querySelectorAll('.zym-nav-panel').forEach((panel) => {
      const item = panel.closest('.menu-list__list-item');
      const trigger = item?.querySelector(':scope > .menu-list__link');
      const inner = panel.parentElement;
      if (!trigger || !inner || window.innerWidth < 750) return;
      const label = trigger.querySelector('.menu-list__link-title') || trigger;
      const labelStyle = getComputedStyle(label);
      const labelLeft = label.getBoundingClientRect().left + parseFloat(labelStyle.paddingLeft || 0);
      const innerLeft = inner.getBoundingClientRect().left + parseFloat(getComputedStyle(inner).paddingLeft || 0);
      const rightLimit = document.documentElement.clientWidth - 24 - panel.getBoundingClientRect().width;
      const left = Math.max(24, Math.min(labelLeft, rightLimit));
      panel.style.setProperty('--zym-menu-offset', (left - innerLeft) + 'px');
    });
  };
  document.addEventListener('pointerover', (event) => {
    if (event.target.closest('header-menu')) alignZymMenus();
  });
  document.addEventListener('focusin', (event) => {
    if (event.target.closest('header-menu')) alignZymMenus();
  });
  window.addEventListener('resize', alignZymMenus);
  document.addEventListener('shopify:section:load', alignZymMenus);
  document.fonts.ready.then(alignZymMenus);
  } catch(e) { console.error(e); }
})();

})();
